import { TimePicker } from '@material-ui/pickers';
import React from 'react';
import { ReactComponent as Down } from 'assets/images/down.svg';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.module.scss';

const _timePicker = (props) => {
  const { value, handleChange, minutesStep, className } = props;

  return (
    <TimePicker
      className={classNames(styles.picker, className)}
      variant='inline'
      value={value}
      onChange={handleChange}
      minutesStep={minutesStep}
      InputProps={{ endAdornment: <Down />, disableUnderline: true }}
    />
  );
};

_timePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.elementType, PropTypes.object]).isRequired,
  handleChange: PropTypes.func.isRequired,
  minutesStep: PropTypes.number.isRequired,
  className: PropTypes.string
};
_timePicker.defaultProps = {
  className: null
};

export default _timePicker;
